import { CardHeaderActions, DeleteAction, IconButton, useHasPermission } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../../shared/types/permission";

interface Props {
	onEdit: () => void;
	onDelete: () => void;
}

export const ClippingDetailsHeaderActions: FC<Props> = ({ onEdit, onDelete }) => {
	const { t } = useTranslation();
	const canUpdate = useHasPermission<PermissionName>(["clipping.update"]);
	const canDelete = useHasPermission<PermissionName>(["clipping.delete"]);

	return (
		<CardHeaderActions>
			{canUpdate && <IconButton size="small" icon="edit" color="primary" title={t("Edit clipping")} onClick={onEdit} />}
			{canDelete && (
				<DeleteAction
					buttonLabel={t("Delete clipping")}
					iconButton={true}
					action={onDelete}
					title={t("Delete clipping")}
					heading={t("Delete clipping")}
					labels={{ close: t("Close"), confirm: t("Confirm") }}
					size="small"
				>
					{t("Are you sure you want to delete this clipping?")}
				</DeleteAction>
			)}
		</CardHeaderActions>
	);
};
